import React from "react";
import {styled, theme, Text} from "@reside/ui";

/**
 * Quicksight dashboard grants live in reside-integrations (AWS), not reporting
 * permissions. Bulk edit is not supported yet — edit dashboards per user.
 */
export const BulkQuicksightUnavailable = () => (
  <Card>
    <Header>
      <Title>Quicksight Dashboards</Title>
      <UnavailableBadge>Not available in bulk</UnavailableBadge>
    </Header>
    <Body>
      <Message>
        Quicksight dashboard access can&apos;t be edited for multiple users at
        once. Open a user from the list to manage their dashboards.
      </Message>
    </Body>
  </Card>
);

const Card = styled.div`
  border: 1px solid ${theme.color.gray10};
  border-radius: 8px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

const Header = styled.div`
  align-items: center;
  background: #f0f5ff;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 8px 16px;
`;

const Title = styled(Text)`
  color: ${theme.color.darkBlue100};
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

const UnavailableBadge = styled.span`
  background: ${theme.color.gray100};
  border-radius: 999px;
  color: #ffffff;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  padding: 4px 10px;
  white-space: nowrap;
`;

const Body = styled.div`
  background: #ffffff;
  padding: 16px;
`;

const Message = styled(Text)`
  color: ${theme.color.gray150};
  display: block;
  font-size: 14px;
  line-height: 20px;
`;
